import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

const NavIconWrapper = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    border-radius: 4px;
    background-color: ${props => props.theme.colors.chinchilla};
    a:hover & {
        background: ${props => props.theme.colors.bluemine};
    }

    margin-bottom: 10px;
    transition: background .3s;

    i {
        font-size: 8vw;
        line-height: 0;
        padding: 2vw;
        color: ${props => props.theme.colors.graysuit};

        a:hover & {
            color: ${props => props.theme.colors.tangerine}
        }
    }
`;

const NavIcon = props => (
    <NavIconWrapper iconColor={props.iconColor}>
        <i className={props.iconName} />
    </NavIconWrapper>
);

NavIcon.propTypes = {
    iconName: PropTypes.string.isRequired,
    iconColor: PropTypes.string.isRequired
};

export default NavIcon;



// WEBPACK FOOTER //
// ./src/components/molecules/home/NavIcon.js